import type React from 'react';
import {
  AquariusIcon,
  AriesIcon,
  CancerIcon,
  CapricornIcon,
  GeminiIcon,
  LeoIcon,
  LibraIcon,
  PiscesIcon,
  SagittariusIcon,
  ScorpioIcon,
  TaurusIcon,
  VirgoIcon,
} from './icons/zodiac';
import type { ZodiacSign } from './zodiac';

export type ZodiacIconData = {
  name: ZodiacSign;
  emoji: string;
  icon: React.ComponentType<{ className?: string }>;
  dateRange: string;
  path?: string;
};

export const ZODIAC_SIGNS: ZodiacIconData[] = [
  { name: 'Aries', emoji: '♈️', icon: AriesIcon, dateRange: 'Mar 21 - Apr 19' },
  { name: 'Taurus', emoji: '♉️', icon: TaurusIcon, dateRange: 'Apr 20 - May 20' },
  { name: 'Gemini', emoji: '♊️', icon: GeminiIcon, dateRange: 'May 21 - Jun 20' },
  { name: 'Cancer', emoji: '♋️', icon: CancerIcon, dateRange: 'Jun 21 - Jul 22' },
  { name: 'Leo', emoji: '♌️', icon: LeoIcon, dateRange: 'Jul 23 - Aug 22' },
  { name: 'Virgo', emoji: '♍️', icon: VirgoIcon, dateRange: 'Aug 23 - Sep 22' },
  { name: 'Libra', emoji: '♎️', icon: LibraIcon, dateRange: 'Sep 23 - Oct 22' },
  { name: 'Scorpio', emoji: '♏️', icon: ScorpioIcon, dateRange: 'Oct 23 - Nov 21' },
  { name: 'Sagittarius', emoji: '♐️', icon: SagittariusIcon, dateRange: 'Nov 22 - Dec 21' },
  { name: 'Capricorn', emoji: '♑️', icon: CapricornIcon, dateRange: 'Dec 22 - Jan 19' },
  { name: 'Aquarius', emoji: '♒️', icon: AquariusIcon, dateRange: 'Jan 20 - Feb 18' },
  { name: 'Pisces', emoji: '♓️', icon: PiscesIcon, dateRange: 'Feb 19 - Mar 20' },
];
export * from './icons/planets';
export * from './icons/zodiac';
